import classes from "./Kiosk_viennaPlzen_redesign.module.css";
import {React, useEffect, useState, useRef, Fragment} from "react";
import bck from "../../../store/Vienna/defScr/2f529311-d03d-46a3-a5e1-01aecce4543b.jpg";
import bck2 from "../../../store/Vienna/defScr/fe64807a-76d3-44d9-9a9a-8120d3fe7314.jpg";
import bck3 from "../../../store/Vienna/defScr/2ff1fb60-d141-4d82-b0a9-ed61115c7b56.jpg";
import bck4 from "../../../store/Vienna/defScr/b9400740-ea13-4683-829b-52e3920a0b6e.jpg";
import bck5 from "../../../store/Vienna/defScr/1475152f-9ee7-4e15-91cb-4961525d1e15.jpg";
import axios from "axios";
import { path, assetsBaseUrl } from "../../../routes";
import Tl1 from "../../../store/meet_1.jpg";
import Tl2 from "../../../store/rest_1.jpg";
import Tl3 from "../../../store/rooms_1.jpg";
import Tl4 from "../../../store/jazzbar_1.jpg";
import {CircularProgress} from "@mui/material";
import logo from "../../../store/Vienna/vh_easy_by_WYndham_prop_logo_Pilsen_cmyk.png";
import cloud from "../../../store/cloud-icon-17.png";
import backMenu from "../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Exterior - bez transparentu.jpg"
import video from "../../../store/Vienna_new/video.mp4"
import cnn from "../../../store/Vienna_new/Cnn_logo_red_background.png"
import room from "../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Executive Double Room - 1550170.jpg"
import back from "../../../store/Vienna_new/back-flat-color-outline-icon-free-png.webp"
import suproom from "../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Superior Double Room - 1550188.jpg"
import Sleep from "./VIENNA_PLZEN/Sleep";
import Eat from "./VIENNA_PLZEN/Eat";
import Meet from "./VIENNA_PLZEN/Meet";
import {Expand, Explore} from "@mui/icons-material";
import ExploreVienna from "./VIENNA_PLZEN/Explore";
import MeetingGraph from "./KioskPages/MeetingGraph";
import MeetingStairs from "./KioskPages/MeetingStairs";
import Bar from "./KioskPages/Bar";
import SlideShowKiosk_redesign from "./KioskPages/SlideShowKiosk_redesign";
import SlideShowKiosk_redesign2 from "./SlideShowKiosk_redesign2";
import MeetingStairs2 from "./KioskPages/MeetingStairs2";
import Hls from "hls.js";

/** Org ID Vienna House Plzeň – pouze pro tuto organizaci se zobrazuje plné Vienna menu (Sleep/Eat/Meet/Explore). */
const VIENNA_HOUSE_ORG_ID = '62BDEE7F-9CE9-41BE-A80C-EF69F045D56C';

const Kiosk_viennaPlzen_redesign = (props) => {
    const normalizeRtspUrl = (u) => {
        const s = String(u || '').trim();
        if (!/^rtsp:\/\//i.test(s)) return s;
        const m = s.match(/^rtsp:\/\/([^@/]+)@(.+)$/i);
        if (!m) return s;
        const userinfo = m[1];
        const hostPath = m[2];
        const idx = userinfo.indexOf(':');
        if (idx < 0) return s;
        const user = userinfo.slice(0, idx);
        const passRaw = userinfo.slice(idx + 1);
        let pass = passRaw;
        try { pass = decodeURIComponent(passRaw); } catch (_) {}
        const enc = (v) => encodeURIComponent(v).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`);
        return `rtsp://${enc(user)}:${enc(pass)}@${hostPath}`;
    };
    const [backgrounds, setBackgrounds] = useState([bck, bck2, bck3, bck4, bck5]);
    const [currentIndexA, setCurrentIndexA] = useState(0);
    const [currentIndexnews, setCurrentIndexnews] = useState(0);
    const [actTime, setactTime] = useState("");
    const [actDate, setactDate] = useState("");
    const [roomName, setroomName] = useState(props.roomName);
    const [logoOrg, setLogoOrg] = useState(props.logoOrg);
    const [news, setNews] = useState([]);
    const [news2, setNews2] = useState();

    const [newsData, setNewsData] = useState([]);
    const [weatherData, setWeatherData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [state, setState] = useState(0);
    const [language, setLanguage] = useState(0);
    const [footerShow, setfooterShow] = useState(2);
    const [bodyRes, setbodyRes] = useState(2);
    const [step, setStep] = useState(0);
    // Počáteční skupina z URL (?group=30), aby slideshow načetl správné karty hned (ne až po getOrg)
    const getGroupFromUrl = () => {
        if (typeof window === 'undefined') return null;
        const p = new URLSearchParams(window.location.search);
        const g = Number(p.get('group'));
        return Number.isFinite(g) && g > 0 ? g : null;
    };
    const [group, setGroup] = useState(() => {
        const urlGroup = getGroupFromUrl();
        return urlGroup != null ? urlGroup : 0;
    });
    const [deviceRoomGroup, setDeviceRoomGroup] = useState(null);
    // Org ID resolved from props or from device settings response (deviceOrgId)
    const [resolvedOrgId, setResolvedOrgId] = useState(props.org || null);
    // Sync resolvedOrgId when props.org changes (e.g. URL navigation)
    useEffect(() => { if (props.org) setResolvedOrgId(props.org); }, [props.org]);
    const [header, setHeader] = useState(true);
    // Start directly on slideshow to avoid initial "menu flicker" on kiosk URL.
    // The view can still change later based on fetched data (meetings / kiosk state).
    const [newstep, setNewStep] = useState(12);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const liveCfgSigRef = useRef('');
    const loadSettingsRef = useRef(null);
    const liveVideoRef = useRef(null);
    const liveEnsureInFlightRef = useRef(false);
    // Pojistka: když přímý RTSP (LG webOS) nenaběhne, spadneme na serverový
    // HLS most. Reset na false při změně kamery/URL.
    const [directRtspFailed, setDirectRtspFailed] = useState(false);
    // Tvrdý re-init HLS: bump → celé hls.js se zničí a postaví znovu. Spouští
    // se, když se vykreslené snímky přestanou měnit (decoder freeze), což
    // měkký watchdog (currentTime) nepozná.
    const [liveReinit, setLiveReinit] = useState(0);

    const [logoHeader , setLogoHeader] = useState();
    const [meetingsNow, setMeetingsNow] = useState([]);
    const [meetingPageIndex, setMeetingPageIndex] = useState(0);
    const MEETINGS_PER_PAGE = 12;
    const pageResetTimerRef = useRef(null);

    // --- Demo režim z URL (demoRatio=9:16 | 16:9 | 4:3): obsah do rohů, hodiny/logo se přizpůsobí ---
    const demoRatio = typeof window !== 'undefined' ? (new URLSearchParams(window.location.search).get('demoRatio') || '') : '';
    const demoRatioClass = demoRatio === '9:16' ? classes.demoRatio916 : demoRatio === '16:9' ? classes.demoRatio169 : demoRatio === '4:3' ? classes.demoRatio43 : '';
    useEffect(() => {
        if (typeof window === 'undefined' || !demoRatio) return;
        console.log('[Kiosk Demo – uvnitř iframe]', {
            demoRatioZUrl: demoRatio,
            viewportIframe: `${window.innerWidth}×${window.innerHeight}`,
            očekávanýPoměr: demoRatio === '9:16' ? '9:16 (portrét)' : demoRatio === '16:9' ? '16:9 (landscape)' : demoRatio === '4:3' ? '4:3' : '?',
        });
    }, [demoRatio]);

    // --- Nastavení kiosku: default → device settings (backend) → URL overrides ---
    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
    const getUrlOverrides = () => {
        if (typeof window === 'undefined') return {};
        const p = new URLSearchParams(window.location.search);
        const out = {};
        const allowUrlOverrides = String(p.get('allowUrlOverrides') || '0') === '1';

        const secRaw = Number(p.get('slideInterval'));
        if (allowUrlOverrides && Number.isFinite(secRaw)) out.slideIntervalSec = clamp(Math.floor(secRaw), 3, 300);

        const fit = String(p.get('fit') || '').toLowerCase();
        if (allowUrlOverrides && (fit === 'contain' || fit === 'cover')) out.objectFit = fit;

        if (allowUrlOverrides && p.has('showLogo')) out.showLogo = String(p.get('showLogo') ?? '1') !== '0';
        if (allowUrlOverrides && p.has('showClock')) out.showClock = String(p.get('showClock') ?? '1') !== '0';
        if (allowUrlOverrides && p.has('showDate')) out.showDate = String(p.get('showDate') ?? '1') !== '0';
        if (allowUrlOverrides && p.has('showTemp')) out.showTemp = String(p.get('showTemp') ?? '1') !== '0';

        const groupRaw = Number(p.get('group'));
        if (Number.isFinite(groupRaw) && groupRaw > 0) out.groupOverride = Math.floor(groupRaw);

        const meetingColor = allowUrlOverrides ? String(p.get('meetingColor') || '').trim() : '';
        if (meetingColor) out.meetingTextColor = meetingColor;

        const meetingBgColor = allowUrlOverrides ? String(p.get('meetingBgColor') || p.get('meetingBg') || '').trim() : '';
        if (meetingBgColor) out.meetingBgColor = meetingBgColor;

        const webZoomRaw = Number(p.get('webZoom'));
        if (allowUrlOverrides && Number.isFinite(webZoomRaw) && webZoomRaw > 0) {
            out.webEmbedZoom = clamp(webZoomRaw, 0.5, 3);
        }
        const webOffsetYRaw = Number(p.get('webOffsetY'));
        if (allowUrlOverrides && Number.isFinite(webOffsetYRaw)) {
            out.webEmbedOffsetY = clamp(webOffsetYRaw, -200, 200);
        }

        return out;
    };
    const defaults = {
        slideIntervalSec: 15,
        objectFit: 'contain', // contain = celý obrázek vždy vidět; cover = vyplnit displej (ořízne)
        // Default: čistý fullscreen slideshow pro nové zákazníky (bez hlavičky)
        showLogo: false,
        showClock: false,
        showDate: false,
        showTemp: false,
        groupOverride: null,
        videoGroupId: null,
        slideshowGroupId: null,
        slideshowGroupIds: [],
        liveCameraEnabled: false,
        liveCameraUrl: null,
        liveCameraName: null,
        liveCameraKey: null,
        // Vynutit přímé přehrávání RTSP v <video src> (bez serverového ffmpeg
        // mostu). Pro LG webOS digital signage, které RTSP umí nativně.
        // Když true, nezávisí to na detekci user-agentu.
        liveCameraDirectRtsp: false,
        // Natvrdo přinutit jít přes serverový ffmpeg HLS most — přímý RTSP se
        // vůbec nezkusí (ani na webOS). Má přednost před liveCameraDirectRtsp.
        liveCameraForceServer: false,
        // Default meeting colors (used when there is an active meeting view)
        meetingTextColor: '#ffffff',
        meetingBgColor: '#003366',
        slideshowPriority: false, // Pokud true, slideshow má prioritu před meetingem
        displayArrows: {},
        // Pozadí celé stránky když neběží meeting (logo view, plocha kolem slideshow)
        backgroundColor: '#ffffff',
        /** Web/PDF v iframe: násobitel měřítka (1 = starý default; pod 1 = oddálit kalendář; max 3) */
        webEmbedZoom: 0.88,
        /** Vertikální posun iframe v px (kladné = obsah níž) */
        webEmbedOffsetY: 60,
        // Hlavička kiosku (logo, čas, datum, teplota)
        headerBackgroundColor: '#eeeeee',
        headerTextColor: '#333333',
        headerTimeTempColor: '#d92027'
    };
    const [kioskCfg, setKioskCfg] = useState(() => ({ ...defaults, ...getUrlOverrides() }));
    const [kioskCfgReady, setKioskCfgReady] = useState(() => {
        if (typeof window === 'undefined') return true;
        const p = new URLSearchParams(window.location.search);
        const roomIdRaw = p.get('room');
        const deviceId = roomIdRaw != null ? parseInt(roomIdRaw, 10) : NaN;
        // If we have a device id, we will fetch device settings. Until then, don't render header
        // with default values (prevents logo/time flicker).
        return !Number.isFinite(deviceId);
    });


    const getOrg = async (deviceGroup) => {
        if (!resolvedOrgId) return;
        try {
            // Skupina z URL má absolutní prioritu - pokud je v URL, NIKDY ji nepřepisovat
            const urlGroup = getGroupFromUrl();
            if (urlGroup != null) {
                // Skupina z URL už je nastavena - nepřepisovat, jen načíst logo
                const response = await axios.get(`${path}/getOrganization/${resolvedOrgId}`);
                if (response.data.length > 0) {
                    const logoPath = response.data[0].logoPath;
                    setLogoHeader(logoPath ? `${assetsBaseUrl}${logoPath}?t=${Date.now()}` : null);
                }
                return;
            }
            const response = await axios.get(`${path}/getOrganization/${resolvedOrgId}`);
            if (response.data.length > 0) {
                const logoPath = response.data[0].logoPath;
                setLogoHeader(logoPath ? `${assetsBaseUrl}${logoPath}?t=${Date.now()}` : null);
                // Group měnit jen když byl předán explicitní parametr (deviceRoomGroup z load()) – když getOrg()
                // voláme bez argumentu (needUpdate / onOnline), neměnit group, jinak by se přepsala na 0 a zmizela slideshow.
                const hasExplicitGroup = deviceGroup !== undefined;
                if (hasExplicitGroup) {
                    const hasDeviceGroup = deviceGroup != null && Number.isFinite(Number(deviceGroup)) && Number(deviceGroup) >= 0;
                    const resolved = hasDeviceGroup ? Number(deviceGroup) : 0;
                    if (!hasDeviceGroup && process.env.NODE_ENV === 'development') {
                        console.log('[Kiosk] Zařízení nemá nastavenou skupinu (roomGroup), zobrazí se prázdný slideshow. deviceRoomGroup:', deviceGroup);
                    }
                    setGroup(resolved);
                }
            }
        } catch (error) {
            // ignore
        }
    };

    // Load per-device settings from backend (based on ?room=<deviceId> or props.room)
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const p = new URLSearchParams(window.location.search);
        const roomFromUrl = p.get('room');
        const roomFromProps = props.room != null && props.room !== '' ? String(props.room) : null;
        const roomIdRaw = roomFromUrl || roomFromProps;
        const deviceId = roomIdRaw != null ? parseInt(roomIdRaw, 10) : NaN;
        if (!Number.isFinite(deviceId)) return;

        let cancelled = false;
        const normalize = (s) => {
            const out = {};
            if (typeof s?.slideIntervalSec === 'number' && Number.isFinite(s.slideIntervalSec)) {
                out.slideIntervalSec = clamp(Math.floor(s.slideIntervalSec), 3, 300);
            }
            if (s?.objectFit === 'contain' || s?.objectFit === 'cover') out.objectFit = s.objectFit;
            if (typeof s?.showLogo === 'boolean') out.showLogo = s.showLogo;
            if (typeof s?.showClock === 'boolean') out.showClock = s.showClock;
            if (typeof s?.showDate === 'boolean') out.showDate = s.showDate;
            if (typeof s?.showTemp === 'boolean') out.showTemp = s.showTemp;
            if (typeof s?.slideshowPriority === 'boolean') out.slideshowPriority = s.slideshowPriority;
            if (typeof s?.meetingTextColor === 'string' && s.meetingTextColor.trim() !== '') {
                out.meetingTextColor = s.meetingTextColor.trim();
            }
            if (typeof s?.meetingBgColor === 'string' && s.meetingBgColor.trim() !== '') {
                out.meetingBgColor = s.meetingBgColor.trim();
            }
            if (typeof s?.backgroundColor === 'string' && s.backgroundColor.trim() !== '') {
                out.backgroundColor = s.backgroundColor.trim();
            }
            if (typeof s?.headerBackgroundColor === 'string' && s.headerBackgroundColor.trim() !== '') {
                out.headerBackgroundColor = s.headerBackgroundColor.trim();
            }
            if (typeof s?.headerTextColor === 'string' && s.headerTextColor.trim() !== '') {
                out.headerTextColor = s.headerTextColor.trim();
            }
            if (typeof s?.headerTimeTempColor === 'string' && s.headerTimeTempColor.trim() !== '') {
                out.headerTimeTempColor = s.headerTimeTempColor.trim();
            }
            if (s?.displayArrows && typeof s.displayArrows === 'object') out.displayArrows = s.displayArrows;
            if (s?.groupOverride === null) out.groupOverride = null;
            if (typeof s?.groupOverride === 'number' && Number.isFinite(s.groupOverride) && s.groupOverride > 0) {
                out.groupOverride = Math.floor(s.groupOverride);
            }
            if (s?.videoGroupId === null) out.videoGroupId = null;
            if (typeof s?.videoGroupId === 'number' && Number.isFinite(s.videoGroupId) && s.videoGroupId > 0) {
                out.videoGroupId = Math.floor(s.videoGroupId);
            }
            if (s?.slideshowGroupId === null) out.slideshowGroupId = null;
            if (typeof s?.slideshowGroupId === 'number' && Number.isFinite(s.slideshowGroupId) && s.slideshowGroupId > 0) {
                out.slideshowGroupId = Math.floor(s.slideshowGroupId);
            }
            if (Array.isArray(s?.slideshowGroupIds)) {
                out.slideshowGroupIds = s.slideshowGroupIds
                    .map((x) => Number(x))
                    .filter((n) => Number.isFinite(n) && n > 0)
                    .map((n) => Math.floor(n));
            }
            if (typeof s?.liveCameraEnabled === 'boolean') out.liveCameraEnabled = s.liveCameraEnabled;
            if (typeof s?.liveCameraUrl === 'string' && s.liveCameraUrl.trim() !== '') out.liveCameraUrl = normalizeRtspUrl(s.liveCameraUrl.trim());
            if (typeof s?.liveCameraName === 'string' && s.liveCameraName.trim() !== '') out.liveCameraName = s.liveCameraName.trim();
            if (typeof s?.liveCameraKey === 'string' && s.liveCameraKey.trim() !== '') out.liveCameraKey = s.liveCameraKey.trim();
            if (typeof s?.liveCameraDirectRtsp === 'boolean') out.liveCameraDirectRtsp = s.liveCameraDirectRtsp;
            if (typeof s?.liveCameraForceServer === 'boolean') out.liveCameraForceServer = s.liveCameraForceServer;
            if (typeof s?.webEmbedZoom === 'number' && Number.isFinite(s.webEmbedZoom)) {
                out.webEmbedZoom = clamp(s.webEmbedZoom, 0.5, 3);
            }
            if (typeof s?.webEmbedOffsetY === 'number' && Number.isFinite(s.webEmbedOffsetY)) {
                out.webEmbedOffsetY = clamp(s.webEmbedOffsetY, -200, 200);
            }
            return out;
        };

        const load = async (cacheBust = false) => {
            try {
                const orgId = props.org;
                let url = orgId ? `${path}/getDeviceSettings/${deviceId}?orgID=${encodeURIComponent(orgId)}` : `${path}/getDeviceSettings/${deviceId}`;
                if (cacheBust) url += (url.includes('?') ? '&' : '?') + `_t=${Date.now()}`;
                console.log(`[Kiosk] 🔍 Loading device settings: deviceId=${deviceId}, orgId=${orgId?.slice(0, 8) || 'none'}..., url=${url}`);
                const resp = await axios.get(url);
                console.log(`[Kiosk] 📥 Device settings response:`, {
                    deviceId: resp.data?.deviceId,
                    hasSettings: resp.data?.settings !== null && resp.data?.settings !== undefined,
                    settings: resp.data?.settings,
                    deviceRoomGroup: resp.data?.deviceRoomGroup,
                    deviceOrgId: resp.data?.deviceOrgId?.slice(0, 8)
                });
                const rawSettings = resp.data?.settings;
                const deviceSettings = normalize(rawSettings || {});
                console.log(`[Kiosk] 🔄 Normalized device settings:`, deviceSettings);
                const urlOverrides = getUrlOverrides();
                console.log(`[Kiosk] 🔗 URL overrides:`, urlOverrides);
                if (cancelled) return;
                setKioskCfg((prev) => {
                    // Merge: device settings mají prioritu, URL overrides jen pokud jsou explicitně v URL
                    // Pro slideIntervalSec: použít URL override jen pokud je explicitně v URL, jinak použít device setting
                    const merged = { ...prev, ...deviceSettings };
                    // URL overrides aplikovat jen pro parametry, které jsou skutečně v URL
                    const p = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
                    if (p && p.has('slideInterval')) {
                        // slideInterval je explicitně v URL - použít ho
                        merged.slideIntervalSec = urlOverrides.slideIntervalSec;
                    }
                    // Ostatní URL overrides aplikovat normálně (fit, showLogo, atd.)
                    if (urlOverrides.objectFit) merged.objectFit = urlOverrides.objectFit;
                    if (p && p.has('showLogo')) merged.showLogo = urlOverrides.showLogo;
                    if (p && p.has('showClock')) merged.showClock = urlOverrides.showClock;
                    if (p && p.has('showDate')) merged.showDate = urlOverrides.showDate;
                    if (p && p.has('showTemp')) merged.showTemp = urlOverrides.showTemp;
                    if (urlOverrides.groupOverride != null) merged.groupOverride = urlOverrides.groupOverride;
                    if (urlOverrides.meetingTextColor) merged.meetingTextColor = urlOverrides.meetingTextColor;
                    if (urlOverrides.meetingBgColor) merged.meetingBgColor = urlOverrides.meetingBgColor;
                    if (p && p.has('webZoom') && String(p.get('allowUrlOverrides') || '0') === '1' && urlOverrides.webEmbedZoom != null) {
                        merged.webEmbedZoom = urlOverrides.webEmbedZoom;
                    }
                    if (p && p.has('webOffsetY') && String(p.get('allowUrlOverrides') || '0') === '1' && urlOverrides.webEmbedOffsetY != null) {
                        merged.webEmbedOffsetY = urlOverrides.webEmbedOffsetY;
                    }
                    if (deviceSettings.displayArrows) merged.displayArrows = deviceSettings.displayArrows;
                    console.log(`[Kiosk] ✅ Final kiosk config:`, merged);
                    return merged;
                });
                // Skupinu (deviceRoomGroup/group) měnit jen když server explicitně vrátí deviceRoomGroup – jinak by
                // při reloadu po změně jen nastavení (slide interval) mohla chybět hodnota a kiosk by přešel na logo.
                const hasRoomGroupInResponse = Object.prototype.hasOwnProperty.call(resp.data || {}, 'deviceRoomGroup');
                if (hasRoomGroupInResponse) {
                    const rg = resp.data.deviceRoomGroup;
                    const parsedRoomGroup = (rg !== null && rg !== undefined && typeof rg !== 'string' && Number.isFinite(Number(rg)) && Number(rg) >= 0)
                        ? Math.floor(Number(rg))
                        : (typeof rg === 'string' && rg.trim() !== '' && !isNaN(Number(rg)) && Number(rg) >= 0)
                            ? Math.floor(Number(rg))
                            : null;
                    setDeviceRoomGroup(parsedRoomGroup);
                    const urlGroup = getGroupFromUrl();
                    if (parsedRoomGroup == null || Number(parsedRoomGroup) <= 0) {
                        setGroup(0);
                    } else if (urlGroup == null) {
                        setGroup(parsedRoomGroup);
                    }
                    if (process.env.NODE_ENV === 'development') {
                        if (parsedRoomGroup == null) {
                            console.log('[Kiosk] deviceRoomGroup z backendu:', rg, '→ parsed:', parsedRoomGroup);
                        } else {
                            console.log('[Kiosk] deviceRoomGroup nastaveno:', parsedRoomGroup);
                        }
                    }
                }
                // Pokud props.org není k dispozici, použít deviceOrgId ze serveru
                if (!props.org && resp.data?.deviceOrgId) {
                    setResolvedOrgId(resp.data.deviceOrgId);
                }
                // Titul záložky = název zařízení (Kiosk_1, Display_1…), aby se nepletl s jiným zařízením
                const name = resp.data?.deviceDescription;
                if (typeof document !== 'undefined' && name) {
                    document.title = name;
                }
            } catch (e) {
                console.error(`[Kiosk] ❌ Error loading device settings for deviceId=${deviceId}:`, e.message, e.response?.data);
                // ignore if not available
            } finally {
                if (!cancelled) setKioskCfgReady(true);
            }
        };
        loadSettingsRef.current = load;

        load(refreshTrigger > 0); // při refreshTrigger > 0 cache-bust, aby se načetla nová skupina
        const checkForUpdates = async () => {
            if (cancelled) return;
            try {
                const orgId = props.org;
                const url = orgId ? `${path}/getReset/${deviceId}?orgID=${encodeURIComponent(orgId)}` : `${path}/getReset/${deviceId}`;
                const resp = await axios.get(url);
                const need = resp.data?.[0]?.needUpdate;
                if (need === 1 || need === true) {
                    console.log(`[Kiosk] 🔄 Settings changed detected (needUpdate=1), reloading settings...`);
                    try {
                        await axios.post(`${path}/updateReset/${deviceId}`, orgId ? { orgID: orgId } : {});
                    } catch (resetErr) {
                        console.warn(`[Kiosk] ⚠️ Failed to reset needUpdate flag:`, resetErr.message);
                    }
                    await load(true); // cache-bust, aby se načetla nová skupina
                }
            } catch (e) {
                // Ignore errors při kontrole updates
                if (process.env.NODE_ENV === 'development') {
                    console.log(`[Kiosk] Check for updates error (non-critical):`, e.message);
                }
            }
        };
        const runCheck = () => checkForUpdates();
        const t0 = setTimeout(runCheck, 800); // první kontrola brzy po načtení
        const onVisibility = () => {
            if (typeof document !== 'undefined' && document.visibilityState === 'visible') runCheck();
        };
        document.addEventListener('visibilitychange', onVisibility);
        const updateInterval = setInterval(checkForUpdates, 5 * 1000); // rychlejší propagace změn pro non-touch kiosk

        return () => {
            cancelled = true;
            clearTimeout(t0);
            clearInterval(updateInterval);
            document.removeEventListener('visibilitychange', onVisibility);
        };
    }, [props.org, props.room, refreshTrigger]);

    // Heartbeat: oznámení serveru, že terminál běží (pro admin Servis – stav „živý/neživý“)
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const p = new URLSearchParams(window.location.search);
        const roomIdRaw = p.get('room');
        const deviceId = roomIdRaw != null ? parseInt(roomIdRaw, 10) : NaN;
        if (!Number.isFinite(deviceId)) return;

        const sendHeartbeat = () => {
            const payload = {
                url_id: p.get('id'),
                url_room: p.get('room'),
                url_orgID: p.get('orgID'),
                url_kiosk: p.get('kiosk'),
            };
            axios.post(`${path}/heartbeat/${deviceId}`, payload).catch(() => {});
        };
        sendHeartbeat();
        const interval = setInterval(sendHeartbeat, 60000); // každou minutu
        return () => clearInterval(interval);
    }, []);

    // Soft refresh: při needUpdate stáhnout jen metadata (obrázky z cache). Při výpadku WiFi nevoláme.
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const p = new URLSearchParams(window.location.search);
        const roomIdRaw = p.get('room');
        const deviceId = roomIdRaw != null ? parseInt(roomIdRaw, 10) : NaN;
        if (!Number.isFinite(deviceId)) return;

        let cancelled = false;
        const check = async () => {
            if (cancelled) return;
            if (typeof navigator !== 'undefined' && !navigator.onLine) return;
            try {
                const orgId = props.org;
                const url = orgId ? `${path}/getReset/${deviceId}?orgID=${encodeURIComponent(orgId)}` : `${path}/getReset/${deviceId}`;
                const resp = await axios.get(url);
                const need = resp?.data?.[0]?.needUpdate;
                if (need === 1 || need === true) {
                    try {
                        await axios.post(`${path}/updateReset/${deviceId}`, orgId ? { orgID: orgId } : {});
                    } catch (_) {
                        // ignore
                    }
                    // Načíst hned nastavení (včetně deviceRoomGroup) – při odebrání ze skupiny se musí objevit logo bez ručního refreshi
                    const loadFn = loadSettingsRef.current;
                    if (typeof loadFn === 'function') {
                        await loadFn(true);
                    }
                    getOrg();
                    fetch_meetings();
                    setRefreshTrigger((prev) => prev + 1);
                }
            } catch (_) {
                // ignore (offline nebo backend nepodporuje)
            }
        };

        const onOnline = () => {
            const loadFn = loadSettingsRef.current;
            if (typeof loadFn === 'function') loadFn(true);
            getOrg();
            fetch_meetings();
            setRefreshTrigger((prev) => prev + 1);
        };

        const interval = setInterval(check, 15000);
        check();
        window.addEventListener('online', onOnline);
        return () => {
            cancelled = true;
            clearInterval(interval);
            window.removeEventListener('online', onOnline);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.org]);

    const fetch_meetings = async () => {
        //let state = (await getDevice())
        const dt = new Date
        const date = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`
        const actTime = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}T${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}:${String(dt.getSeconds()).padStart(2, "0")}`;
        try {
            const response = await axios.get(`${path}/getRecordsNowV2?orgID=${props.org}&day=${actTime}`);
            decision_handler(response.data)
        } catch (error) {
            console.log(error)
            setStep(0)
        }

    }

    const getDevice = async () => {
        try {
            let response = await axios.get(`${path}/getRoomDetail/${props.id == 1 ? 40 : 41}`);
            setState(response.data[0].KioskState)
            return response.data[0].KioskState
        } catch (err) {
            console.log(err)
            return null
        }
    }

    const decision_handler = (records) => {
        const raw = Array.isArray(records) ? records : [];
        const now = Date.now();
        const list = raw.filter((r) => {
            const dateToVal = r.dateTo;
            if (!dateToVal) return true;
            const s = typeof dateToVal === 'string' ? dateToVal : (dateToVal && typeof dateToVal.toISOString === 'function') ? dateToVal.toISOString() : '';
            if (!s) return true;
            const match = String(s).match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{1,2}):(\d{1,2})/);
            if (!match) return true;
            const [, y, mo, d, h, mi] = match;
            const endMs = new Date(Number(y), Number(mo) - 1, Number(d), Number(h), Number(mi), 0).getTime();
            return endMs > now;
        });
        const hasMeetings = list.length > 0;
        setMeetingsNow(list);
        const hasSlideshowGroup = Number(kioskCfg.slideshowGroupId || group) > 0;
        const hasVideoGroup = Number(kioskCfg.videoGroupId) > 0;
        const noGroup = !hasSlideshowGroup && !hasVideoGroup && (deviceRoomGroup == null || Number(deviceRoomGroup) <= 0);
        const slideshowHasPriority = kioskCfg.slideshowPriority === true;
        // Pokud je slideshowPriority zapnuté: slideshow má prioritu před meetingem
        // Jinak: meeting má prioritu před slideshow
        if (slideshowHasPriority && !noGroup) {
            setNewStep(12); // Slideshow skupina má prioritu
        } else if (hasMeetings) {
            setNewStep(99); // Meeting má prioritu (pokud není slideshowPriority)
        } else if (!noGroup) {
            setNewStep(12); // Slideshow skupina, pokud není meeting
        } else {
            setNewStep(0); // Fallback logo, pokud není meeting ani skupina
        }
    };

    // Po změně skupiny znovu nastavit krok. Pokud je slideshowPriority zapnuté: slideshow má prioritu před meetingem
    useEffect(() => {
        const hasSlideshowGroup = Number(kioskCfg.slideshowGroupId || group) > 0;
        const hasVideoGroup = Number(kioskCfg.videoGroupId) > 0;
        const noGroup = !hasSlideshowGroup && !hasVideoGroup && (deviceRoomGroup == null || Number(deviceRoomGroup) <= 0);
        const slideshowHasPriority = kioskCfg.slideshowPriority === true;
        // Pokud je slideshowPriority zapnuté: slideshow má prioritu před meetingem
        // Jinak: meeting má prioritu před slideshow
        if (slideshowHasPriority && !noGroup) {
            setNewStep(12); // Slideshow skupina má prioritu
        } else if (meetingsNow.length > 0) {
            setNewStep(99); // Meeting má prioritu (pokud není slideshowPriority)
        } else if (!noGroup) {
            setNewStep(12); // Slideshow skupina, pokud není meeting
        } else {
            setNewStep(0); // Fallback logo, pokud není meeting ani skupina
        }
    }, [deviceRoomGroup, group, meetingsNow, kioskCfg.slideshowPriority, kioskCfg.videoGroupId, kioskCfg.slideshowGroupId]);

    const fetchNews = async (gr) => {
        try {
            let tmp = []
            const response = await axios.get(`${path}/getNews`);
            for (let i = 0; i < response.data.length; i++) {
                tmp.push(response.data[i].description)
            }
            setNews(tmp)
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    const resetscreen = () => {
        console.log("reset screen")
        setNewStep(0)
    };

    /*
    STEPS
    0 - MENU + FOOTER PREZ
    1 - MEETING TXT + FOOTER MENU
    2 - MEETING MAP WITHOUT FOOTER
    3 - MEETING EVENTS + FOOTER MENU
    4 - RESTAURANT + FOOTER MENU
    5 - ROOMS + FOOTER MENU
    6 - BAR + FOOTER MENU
    7 - MEETING SLIDESHOW + FOOTER MENU
    8 - MEETING LIST WITHOUT FOOTER
    9 - MEETING DETAIL WITHOUT FOOTER
    * */
    const changeStep_handler = (step) => {
        setStep(step);
    }
    const changeGroup_handler = (id) => {
        setGroup(id);
    }
    const reload_handler = () => {
        console.log("reload_handler")
    }

    useEffect(() => {
        const apiKeyNews = '103cea4011e44292b5c47cd9c7808d1c';
        const apiUrlNews = `https://newsapi.org/v2/top-headlines?country=us&apiKey=${apiKeyNews}`;
        const apiKeyWea = '53aaf5c2175c0194becf66b6a9f26436';
        const city = 'Praha';
        const apiUrlWea = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKeyWea}&units=metric`;
        const WEATHER_CACHE_MINUTES = 10;
        const cacheKey = `kiosk_weather_${city}`;

        const fetchWeather = async () => {
            try {
                const cached = (typeof sessionStorage !== 'undefined') && sessionStorage.getItem(cacheKey);
                if (cached) {
                    const { temp, ts } = JSON.parse(cached);
                    if (Date.now() - ts < WEATHER_CACHE_MINUTES * 60 * 1000) {
                        setWeatherData(temp);
                        setLoading(false);
                        return;
                    }
                }
                const response = await fetch(apiUrlWea);
                if (!response.ok) {
                    throw new Error('Chyba při načítání dat o počasí');
                }
                const data = await response.json();
                const temp = Math.round(data.main.temp);
                setWeatherData(temp);
                if (typeof sessionStorage !== 'undefined') {
                    sessionStorage.setItem(cacheKey, JSON.stringify({ temp, ts: Date.now() }));
                }
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        const updateMinute = () => {
            let dt = new Date
            setactTime(`${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`)
            setactDate(`${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`)
        };
        updateMinute()
        const intervalId = setInterval(updateMinute, 1000);

        fetchWeather();
        return () => clearInterval(intervalId);
    }, []);
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexA((prevIndex) => (prevIndex + 1) % backgrounds.length);
        }, 10000);
        return () => {
            clearInterval(intervalId);
        };
    }, [backgrounds]);

    useEffect(() => {
        const intervalIdNews = setInterval(() => {
            setCurrentIndexnews((prevIndex) => (prevIndex + 1) % news.length);
        }, 15000);
        return () => {
            clearInterval(intervalIdNews);
        };
    }, [news]);

    useEffect(() => {
        const intervalfetchmeeting = setInterval(() => {
            fetch_meetings()
        }, 60 * 1000);
        return () => {
            clearInterval(intervalfetchmeeting);
        };
    }, [news]);

    useEffect(() => { setMeetingPageIndex(0); }, [meetingsNow.length]);

    useEffect(() => {
        const totalPages = Math.ceil(meetingsNow.length / MEETINGS_PER_PAGE);
        if (totalPages <= 1) return;
        const intervalId = setInterval(() => {
            setMeetingPageIndex((p) => (p + 1) % totalPages);
        }, 30 * 1000);
        return () => clearInterval(intervalId);
    }, [meetingsNow.length]);

    const changeMeetingPage = (newPage) => {
        setMeetingPageIndex(newPage);
        if (pageResetTimerRef.current) clearTimeout(pageResetTimerRef.current);
        if (newPage !== 0) {
            pageResetTimerRef.current = setTimeout(() => {
                setMeetingPageIndex(0);
            }, 20 * 1000);
        }
    };
    useEffect(() => {
        return () => { if (pageResetTimerRef.current) clearTimeout(pageResetTimerRef.current); };
    }, []);

    useEffect(() => {

        const hourDelay = 60 * 60 * 1000; // 1 hour in milliseconds
        const refreshPage = setTimeout(() => {
            console.log("reload_handler")
        }, hourDelay);


        return () => {
            clearTimeout(refreshPage);
        };
    }, []);

    // Sledovat skupinu z URL, ale respektovat deviceRoomGroup – pokud je null (zařízení odebráno), nepřepisovat group zpět na URL
    useEffect(() => {
        const urlGroup = getGroupFromUrl();
        // Pokud zařízení nemá skupinu (deviceRoomGroup null), ponechat group=0 i když je v URL skupina
        if (deviceRoomGroup == null) return;
        if (urlGroup != null && group !== urlGroup) {
            console.log('[Kiosk] Skupina z URL:', urlGroup, 'přepisuje aktuální skupinu:', group);
            setGroup(urlGroup);
        }
    }, [group, deviceRoomGroup]);

    useEffect(() => {
        const urlGroup = getGroupFromUrl();
        // Pokud zařízení nemá skupinu (deviceRoomGroup null), vymazat slideshow i když je v URL skupina
        if (deviceRoomGroup == null || Number(deviceRoomGroup) <= 0) {
            setGroup(0);
            // Stále načíst logo z organizace
            if (resolvedOrgId) (async () => {
                try {
                    const response = await axios.get(`${path}/getOrganization/${resolvedOrgId}`);
                    if (response.data && response.data.length > 0) {
                        const logoPath = response.data[0].logoPath;
                        setLogoHeader(logoPath ? `${assetsBaseUrl}${logoPath}?t=${Date.now()}` : null);
                    }
                } catch (_) {}
            })();
        } else if (urlGroup != null) {
            // Zařízení má skupinu a je v URL skupina – URL má prioritu
            if (group !== urlGroup) {
                setGroup(urlGroup);
            }
            // Načíst logo z organizace
            if (resolvedOrgId) (async () => {
                try {
                    const response = await axios.get(`${path}/getOrganization/${resolvedOrgId}`);
                    if (response.data && response.data.length > 0) {
                        const logoPath = response.data[0].logoPath;
                        setLogoHeader(logoPath ? `${assetsBaseUrl}${logoPath}?t=${Date.now()}` : null);
                    }
                } catch (_) {}
            })();
        } else {
            // Bez skupiny v URL použít skupinu zařízení
            getOrg(deviceRoomGroup);
        }
        fetchNews();
        fetch_meetings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [kioskCfg.groupOverride, deviceRoomGroup, resolvedOrgId]);


    const language_handler = () => {
        language == 0 ? setLanguage(1) : setLanguage(0)
    }
    const loader = <CircularProgress color="error" size={100}/>
    /*
    STEPS
    0 - MENU + FOOTER PREZ
    1 - MEETING TXT + FOOTER MENU
    2 - MEETING MAP WITHOUT FOOTER
    3 - MEETING EVENTS + FOOTER MENU
    4 - RESTAURANT + FOOTER MENU
    5 - ROOMS + FOOTER MENU
    6 - BAR + FOOTER MENU
    7 - MEETING SLIDESHOW + FOOTER MENU
    8 - MEETING LIST + FOOTER MENU
    9 - MEETING DETAIL WITHOUT FOOTER
    * */

    const isViennaOrg = props.org && String(props.org).toUpperCase() === VIENNA_HOUSE_ORG_ID.toUpperCase();

    const mainMenu = <>
        <div className={classes.bodyContainer}>
            <img src={backMenu}/>
            <div className={classes.circle}/>
            <div className={`${classes.buttonCirc} ${classes.sleepBT}`} onClick={() => {
                setNewStep(1)
            }}>Sleep
            </div>
            <div className={`${classes.buttonCirc} ${classes.eatBT}`} onClick={() => {
                setNewStep(2)
            }}>Eat
            </div>
            <div className={`${classes.buttonCirc} ${classes.meetBT}`} onClick={() => {
                setNewStep(3)
            }}>Meet
            </div>
            <div className={`${classes.buttonCirc} ${classes.exploreBT}`} onClick={() => {
                setNewStep(4)
            }}>Explore
            </div>
            <div className={`${classes.cnnnews}`}>
                <div className={classes.cnnIMG}><img src={cnn}/></div>
                <div className={classes.cnnTXT}><label>{news.length > 0 && news[currentIndexnews]}</label></div>

            </div>
        </div>
        <div className={classes.footerContainer}>

        </div>
    </>;

    const noMeetingBgColor = kioskCfg.backgroundColor || defaults.backgroundColor;
    /** Pro jiné než Vienna House org: jen logo organizace na pozadí z nastavení (žádné Vienna menu). */
    const genericNoGroupView = (
        <div style={{
            flex: 1,
            width: '100%',
            minHeight: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: noMeetingBgColor
        }}>
            {logoHeader && (
                <img src={logoHeader} alt="Logo" style={{ maxWidth: '60%', maxHeight: '50%', objectFit: 'contain' }} />
            )}
        </div>
    );

    const setNewStep_handler = (x) => {
        setNewStep(x)
    }

    const headerSections = [];
    if (kioskCfg.showLogo) {
        headerSections.push(
            <div key="logo" className={classes.box}>
                {logoHeader && (
                    <img
                        src={logoHeader}
                        alt={"logo"}
                        onClick={() => {
                        reload_handler()
                        }}
                    />
                )}
                </div>
        );
    }
    const headerTextColor = kioskCfg.headerTextColor || defaults.headerTextColor;
    const headerTimeTempColor = kioskCfg.headerTimeTempColor || defaults.headerTimeTempColor;
    const headerBgColor = kioskCfg.headerBackgroundColor || defaults.headerBackgroundColor;
    if (kioskCfg.showTemp) {
        headerSections.push(
            <div key="temp" className={classes.boxC}>
                <img src={cloud} alt="weather" />
                <div className={classes.timeC} style={{ color: headerTimeTempColor }}>{weatherData && `${weatherData}\u00b0`}</div>
            </div>
        );
    }
    if (kioskCfg.showClock || kioskCfg.showDate) {
        headerSections.push(
            <div key="time" className={classes.boxB}>
                {kioskCfg.showClock && <div className={classes.timeA} style={{ color: headerTimeTempColor }}>{actTime}</div>}
                {kioskCfg.showClock && kioskCfg.showDate && <div className={classes.lineT} style={{ backgroundColor: headerTextColor }}>a</div>}
                {kioskCfg.showDate && <div className={classes.timeB} style={{ color: headerTextColor }}>{actDate}</div>}
            </div>
        );
    }
    const showHeader = kioskCfgReady && header && headerSections.length > 0;

    const totalMeetingPages = Math.max(1, Math.ceil(meetingsNow.length / MEETINGS_PER_PAGE));
    const hasPrevMeetingPage = totalMeetingPages > 1 && meetingPageIndex > 0;
    const hasNextMeetingPage = totalMeetingPages > 1 && meetingPageIndex < totalMeetingPages - 1;
    const visibleMeetings = meetingsNow.slice(
        meetingPageIndex * MEETINGS_PER_PAGE,
        (meetingPageIndex + 1) * MEETINGS_PER_PAGE
    );

    const meetingView = (
        <div
            className={classes.meetingView}
            style={{
                // Čistá barva z nastavení kiosku – žádný slideshow obrázek na pozadí
                backgroundColor: kioskCfg.meetingBgColor || defaults.meetingBgColor
            }}
        >
            <div className={classes.meetingHeader}>
                <div className={classes.meetingHeaderLeft}>
                    <div
                        className={classes.meetingTitle}
                        style={{ color: kioskCfg.meetingTextColor || defaults.meetingTextColor }}
                    >
                        MEETINGS TODAY
                    </div>
                    <div
                        className={classes.meetingDate}
                        style={{ color: kioskCfg.meetingTextColor || defaults.meetingTextColor }}
                    >
                        {actDate}
                    </div>
                </div>
            </div>
            <div className={classes.meetingList}>
                {visibleMeetings.map((item, idx) => {
                    const roomName = item.roomDescription || item.room || '';
                    const meetingTitleRaw = item.recordDescription || item.description || item.txt || '';
                    const meetingTitleMaxLen = 64;
                    const meetingTitle = meetingTitleRaw.length > meetingTitleMaxLen
                        ? meetingTitleRaw.substring(0, meetingTitleMaxLen - 3).trim() + '…'
                        : meetingTitleRaw;
                    const logoUrl = item.path
                        ? `${assetsBaseUrl}${(item.path || '').replace(/\\/g, '/')}?t=${Date.now()}`
                        : null;
                    const timeFrom = (item.dateFrom || '').substring(11, 16);
                    const timeTo = (item.dateTo || '').substring(11, 16);
                    const timeLabel = timeFrom && timeTo ? `${timeFrom} - ${timeTo}` : '';
                    const textColor = kioskCfg.meetingTextColor || defaults.meetingTextColor;
                    const globalIdx = meetingPageIndex * MEETINGS_PER_PAGE + idx;
                    return (
                        <div key={item.recordID || item.id || globalIdx} className={classes.meetingRow}>
                            <div className={classes.meetingRowLeft}>
                                <div className={classes.meetingLogoWrap}>
                                    {logoUrl ? (
                                        <img src={logoUrl} alt={roomName || meetingTitle || 'meeting'} />
                                    ) : null}
                                </div>
                                <div className={classes.meetingInfo}>
                                    {roomName && (
                                        <span className={classes.meetingRoom} style={{ color: textColor }}>
                                            {roomName}
                                        </span>
                                    )}
                                    {meetingTitle && (
                                        <span
                                            className={classes.meetingTitleRow}
                                            style={{ color: textColor }}
                                            title={meetingTitleRaw}
                                        >
                                            {meetingTitle}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className={classes.meetingRowRight}>
                                {(() => {
                                    const deviceId = String(item.cDevice_id || '');
                                    const arrowDir = (kioskCfg.displayArrows || {})[deviceId];
                                    if (!arrowDir) return null;
                                    const d = arrowDir.toLowerCase();
                                    const deg = { right: 0, left: 180, up: -90, down: 90, 'up-right': 45, 'up-left': 135, 'down-right': -45, 'down-left': -135 }[d] ?? 0;
                                    return (
                                        <div
                                            className={classes.meetingRowArrow}
                                            style={{ color: textColor, transform: `rotate(${deg}deg)` }}
                                        >
                                            <svg className={classes.meetingRowArrowSvg} viewBox="0 0 40 24" fill="currentColor" aria-hidden="true">
                                                <rect x="0" y="7" width="22" height="10" rx="1" />
                                                <path d="M20 2 L20 22 L38 12 Z" />
                                            </svg>
                                        </div>
                                    );
                                })()}
                                {timeLabel && (
                                    <span className={classes.meetingTime} style={{ color: textColor }}>
                                        {timeLabel}
                                    </span>
                                )}
                            </div>
                        </div>
                    );
                })}
                {meetingsNow.length === 0 && (
                    <div 
                        className={classes.meetingEmpty}
                        style={{ color: kioskCfg.meetingTextColor || defaults.meetingTextColor }}
                    >
                        No meetings in progress
                    </div>
                )}
            </div>
            {totalMeetingPages > 1 && (
                <div className={classes.meetingFooterNav}>
                    {hasPrevMeetingPage && (
                        <button
                            type="button"
                            className={classes.meetingHeaderNextBtn}
                            style={{
                                color: kioskCfg.meetingTextColor || defaults.meetingTextColor,
                                borderColor: kioskCfg.meetingTextColor || defaults.meetingTextColor
                            }}
                            onClick={() => changeMeetingPage(Math.max(0, meetingPageIndex - 1))}
                        >
                            ◀ PREV
                        </button>
                    )}
                    <span
                        className={classes.meetingPageIndicator}
                        style={{ color: kioskCfg.meetingTextColor || defaults.meetingTextColor }}
                    >
                        {meetingPageIndex + 1} / {totalMeetingPages}
                    </span>
                    {hasNextMeetingPage && (
                        <button
                            type="button"
                            className={classes.meetingHeaderNextBtn}
                            style={{
                                color: kioskCfg.meetingTextColor || defaults.meetingTextColor,
                                borderColor: kioskCfg.meetingTextColor || defaults.meetingTextColor
                            }}
                            onClick={() => changeMeetingPage(Math.min(meetingPageIndex + 1, totalMeetingPages - 1))}
                        >
                            NEXT ▶
                        </button>
                    )}
                </div>
            )}
            {logoHeader && (
                <div className={classes.meetingBottomLogo}>
                    <img src={logoHeader} alt="organization logo" />
                </div>
            )}
        </div>
    );

    const liveCameraUrlRaw = normalizeRtspUrl(String(kioskCfg.liveCameraUrl || '').trim());
    const liveCameraIsHttp = /^https?:\/\//i.test(liveCameraUrlRaw);
    const liveCameraIsRtsp = /^rtsp:\/\//i.test(liveCameraUrlRaw);
    // LG webOS Smart TV — vlastní media pipeline, umí RTSP přímo v <video src>.
    // V tom případě nepouštíme přes náš ffmpeg/HLS most a kamera jede přímo
    // ze své lokální sítě, max kvalita, žádné zatížení našeho serveru.
    const isWebOS = typeof navigator !== 'undefined'
        && /web[0o]s/i.test(String(navigator.userAgent || ''));
    // Přímý RTSP použij když: a) je to webOS (autodetekce), NEBO b) je ručně
    // vynucený přes nastavení displeje (liveCameraDirectRtsp) — pro případy,
    // kdy LG DS nehlásí webOS v user-agentu a autodetekce selže.
    const liveCameraUseDirectRtsp = kioskCfg.liveCameraForceServer !== true // natvrdo přes server → nikdy přímý RTSP
        && (isWebOS || kioskCfg.liveCameraDirectRtsp === true)
        && liveCameraIsRtsp
        && !directRtspFailed; // při selhání přímého RTSP spadni na HLS most
    const liveCameraHlsUrl = kioskCfg.liveCameraKey && liveCameraIsRtsp && !liveCameraUseDirectRtsp
        ? `${path.replace(/\/$/, '')}/live-streams/${encodeURIComponent(kioskCfg.liveCameraKey)}/index.m3u8`
        : null;
    const liveCameraPlayableUrl = liveCameraUseDirectRtsp
        ? liveCameraUrlRaw
        : (liveCameraIsHttp ? liveCameraUrlRaw : (liveCameraHlsUrl || null));
    const liveCameraPlayableUrlResolved = liveCameraPlayableUrl || null;
    const liveCameraIsHls = /\.m3u8(?:$|\?)/i.test(String(liveCameraPlayableUrlResolved || ''));
    // Pokud URL není přímý stream (m3u8/mp4/webm/mov), ale obecná HTTPS stránka
    // (typicky rtsp.me/embed/..., YouTube embed, jiný HLS přehrávač), vyrenderuj
    // ji jako <iframe> místo <video>.
    const liveCameraIsDirectMedia = /\.(m3u8|mp4|webm|mov|m4v)(?:$|\?)/i.test(String(liveCameraPlayableUrlResolved || ''));
    const liveCameraIsIframe = liveCameraIsHttp && !liveCameraIsDirectMedia;
    const liveSettingsSig = JSON.stringify({
        enabled: !!kioskCfg.liveCameraEnabled,
        url: String(kioskCfg.liveCameraUrl || ''),
        key: String(kioskCfg.liveCameraKey || '')
    });

    useEffect(() => {
        if (!kioskCfgReady) return;
        if (!liveCfgSigRef.current) {
            liveCfgSigRef.current = liveSettingsSig;
            return;
        }
        if (liveCfgSigRef.current !== liveSettingsSig) {
            liveCfgSigRef.current = liveSettingsSig;
            // Non-touch kiosks must switch immediately when camera is assigned/removed.
            if (typeof window !== 'undefined') window.location.reload();
        }
    }, [liveSettingsSig, kioskCfgReady]);

    // Při změně kamery/URL znovu povol pokus o přímý RTSP (zruš předchozí fallback).
    useEffect(() => {
        setDirectRtspFailed(false);
    }, [liveCameraUrlRaw, kioskCfg.liveCameraKey]);

    // Ensure RTSP->HLS bridge keeps running.
    // If backend process is down, stale .m3u8 can still exist and show just an old frame.
    useEffect(() => {
        const enabled = kioskCfg.liveCameraEnabled === true;
        const key = String(kioskCfg.liveCameraKey || '').trim();
        // Na webOS přehráváme RTSP přímo v <video src>, backend ffmpeg nepotřeba.
        if (!enabled || !liveCameraIsRtsp || !key || !liveCameraUrlRaw || liveCameraUseDirectRtsp) return;

        let cancelled = false;
        const ensure = async () => {
            if (cancelled || liveEnsureInFlightRef.current) return;
            liveEnsureInFlightRef.current = true;
            try {
                // Ask backend to start/reuse ffmpeg process for this camera key.
                await axios.post(`${path.replace(/\/$/, '')}/live-camera/start`, {
                    cameraKey: key,
                    rtspUrl: liveCameraUrlRaw
                });
            } catch (e) {
                // Keep silent in kiosk runtime; watchdog + next retry will try again.
            } finally {
                liveEnsureInFlightRef.current = false;
            }
        };

        ensure();
        const t = setInterval(ensure, 20000);
        return () => {
            cancelled = true;
            clearInterval(t);
        };
    }, [kioskCfg.liveCameraEnabled, kioskCfg.liveCameraKey, liveCameraIsRtsp, liveCameraUrlRaw, liveCameraUseDirectRtsp]);

    // Fallback for non-touch kiosks: poll settings continuously for live-camera toggles.
    // This ensures both Enable and Disable are reflected even if needUpdate is delayed/missed.
    useEffect(() => {
        const tick = async () => {
            const loadFn = loadSettingsRef.current;
            if (typeof loadFn === 'function') {
                await loadFn(true);
            }
        };
        const t = setInterval(tick, 5000);
        return () => clearInterval(t);
    }, []);

    // HLS playback support for Chrome/Edge (native HLS usually works only in Safari).
    useEffect(() => {
        if (!kioskCfg.liveCameraEnabled || !liveCameraPlayableUrlResolved) return;
        // Iframe (např. rtsp.me embed) přehrává sám — HLS init pro <video> přeskočit.
        if (liveCameraIsIframe) return;
        const videoEl = liveVideoRef.current;
        if (!videoEl) return;

        let hls = null;
        let cancelled = false;

        const tryPlay = () => {
            if (cancelled) return;
            try {
                const p = videoEl.play();
                if (p && typeof p.catch === 'function') p.catch(() => {});
            } catch (_) {}
        };

        if (liveCameraIsHls && Hls.isSupported()) {
            hls = new Hls({
                // Cíl: co nejblíž k live edge, ale stabilní přehrávání.
                lowLatencyMode: false,
                backBufferLength: 10,                // menší backbuffer (méně paměti pro starší snímky)
                liveSyncDurationCount: 2,            // target ~4s za live edge
                liveMaxLatencyDurationCount: 3,      // víc než 6s zpoždění → hls.js seek
                liveDurationInfinity: true,          // chovat se vždy jako live, ne VOD
                maxLiveSyncPlaybackRate: 1.5,        // dohánění latence rychleji (1.5× rychlost)
                startPosition: -1,                   // začni vždy na live edge, ne od začátku playlistu
                manifestLoadingTimeOut: 10000,
            });
            hls.loadSource(liveCameraPlayableUrlResolved);
            hls.attachMedia(videoEl);
            // Při každém načteném levelu zkontroluj drift a okamžitě skoč
            // na live edge pokud je playback víc než 3s za. Tohle reaguje
            // rychleji než časový watchdog níže.
            const seekToLiveIfBehind = () => {
                try {
                    if (!hls || !videoEl || videoEl.seeking) return;
                    const target = (typeof hls.liveSyncPosition === 'number' && isFinite(hls.liveSyncPosition))
                        ? hls.liveSyncPosition
                        : (videoEl.buffered.length > 0 ? videoEl.buffered.end(videoEl.buffered.length - 1) - 2 : null);
                    if (target == null) return;
                    const drift = target - Number(videoEl.currentTime || 0);
                    if (drift > 3) {
                        videoEl.currentTime = target;
                    }
                } catch (_) {}
            };
            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                tryPlay();
                seekToLiveIfBehind();
            });
            hls.on(Hls.Events.LEVEL_LOADED, seekToLiveIfBehind);
            hls.on(Hls.Events.ERROR, (_, data) => {
                if (!data?.fatal) return;
                if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
                    try { hls.startLoad(); } catch (_) {}
                } else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
                    try { hls.recoverMediaError(); } catch (_) {}
                } else {
                    try { hls.destroy(); } catch (_) {}
                }
                // Po recovery hned zkus jump na live edge.
                setTimeout(seekToLiveIfBehind, 500);
            });

            // Soft anti-freeze watchdog: if playback time stalls for too long, recover hls without reloading UI.
            // Sníženo z 12s na 5s — krátké zaseknutí se uzdraví dřív, divák
            // nemusí čekat. Při stálém problému stejně přijde catchup níže.
            let lastTime = 0;
            let stalledForMs = 0;
            const watchdog = setInterval(() => {
                if (cancelled || !hls || !videoEl) return;
                if (videoEl.paused || videoEl.seeking || videoEl.readyState < 2) return;
                const t = Number(videoEl.currentTime || 0);
                if (t > lastTime + 0.03) {
                    lastTime = t;
                    stalledForMs = 0;
                    return;
                }
                stalledForMs += 1000;
                if (stalledForMs >= 5000) {
                    stalledForMs = 0;
                    try { hls.recoverMediaError(); } catch (_) {}
                    try { hls.startLoad(); } catch (_) {}
                    // Po recovery skoč rovnou na live edge, ať divák nevidí staré snímky.
                    try {
                        const buf = videoEl.buffered;
                        if (buf && buf.length > 0) {
                            videoEl.currentTime = Math.max(buf.end(buf.length - 1) - 2, 0);
                        }
                    } catch (_) {}
                    tryPlay();
                }
            }, 1000);

            // Live-edge catchup: agresivně — kontroluje každé 2s, threshold 3s.
            // Když playback zaostane víc než 3s za hls.liveSyncPosition (nebo
            // za bufferem), okamžitě seekneme. Bez tohoto by se "minutové"
            // zpoždění postupně akumulovalo a divák koukal do minulosti.
            const MAX_DRIFT_SEC = 3;
            const catchup = setInterval(() => {
                if (cancelled || !hls || !videoEl) return;
                if (videoEl.paused || videoEl.seeking || videoEl.readyState < 2) return;
                try {
                    const target = (typeof hls.liveSyncPosition === 'number' && isFinite(hls.liveSyncPosition))
                        ? hls.liveSyncPosition
                        : (videoEl.buffered.length > 0 ? videoEl.buffered.end(videoEl.buffered.length - 1) - 2 : null);
                    if (target == null) return;
                    const drift = target - Number(videoEl.currentTime || 0);
                    if (drift > MAX_DRIFT_SEC) {
                        videoEl.currentTime = target;
                    }
                } catch (_) {}
            }, 2000);

            // Detektor zamrzlých snímků (decoder freeze): currentTime může dál
            // narůstat, zatímco se na obrazovce nic nemění (typické pro -c:v
            // copy s nepravidelnými keyframy). requestVideoFrameCallback fíruje
            // jednou za REÁLNĚ vykreslený snímek — když přestane fírovat, ale
            // video "hraje", obraz zamrzl → tvrdý re-init celého hls.js.
            let frozenCheck = null;
            const rvfcSupported = typeof videoEl.requestVideoFrameCallback === 'function';
            if (rvfcSupported) {
                let lastPresentedAt = 0; // performance.now() poslední vykreslené frame
                const onFrame = (now) => {
                    lastPresentedAt = now;
                    if (cancelled || !videoEl) return;
                    try { videoEl.requestVideoFrameCallback(onFrame); } catch (_) {}
                };
                try { videoEl.requestVideoFrameCallback(onFrame); } catch (_) {}
                frozenCheck = setInterval(() => {
                    if (cancelled || !videoEl) return;
                    if (videoEl.paused || videoEl.seeking || videoEl.readyState < 2) return;
                    if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return; // skrytý tab snímky nevykresluje
                    if (!lastPresentedAt) return; // ještě nezačal vykreslovat
                    const sincePresented = (typeof performance !== 'undefined' ? performance.now() : 0) - lastPresentedAt;
                    // 6 s bez nového vykresleného snímku, přestože video "hraje" = freeze.
                    if (sincePresented > 6000) {
                        setLiveReinit((n) => n + 1);
                    }
                }, 1000);
            }

            // Probuzení / restart obrazovky: signage browser obnoví stránku z
            // bfcache a <video> drží poslední (klidně den starý) snímek. Při
            // návratu na viditelnou stránku (visibilitychange / pageshow)
            // proto natvrdo přenačti playlist a skoč na live edge — ať se
            // nikdy nezobrazí cachnutý starý obraz.
            const resyncToLive = () => {
                if (cancelled || !hls || !videoEl) return;
                try { hls.startLoad(); } catch (_) {}
                try {
                    const buf = videoEl.buffered;
                    const target = (typeof hls.liveSyncPosition === 'number' && isFinite(hls.liveSyncPosition))
                        ? hls.liveSyncPosition
                        : (buf && buf.length > 0 ? buf.end(buf.length - 1) - 2 : null);
                    if (target != null) videoEl.currentTime = Math.max(target, 0);
                } catch (_) {}
                tryPlay();
            };
            const onVisible = () => {
                if (typeof document !== 'undefined' && document.visibilityState === 'visible') resyncToLive();
            };
            const onPageShow = (e) => { if (e && e.persisted) resyncToLive(); };
            document.addEventListener('visibilitychange', onVisible);
            window.addEventListener('pageshow', onPageShow);

            return () => {
                cancelled = true;
                clearInterval(watchdog);
                clearInterval(catchup);
                if (frozenCheck) clearInterval(frozenCheck);
                document.removeEventListener('visibilitychange', onVisible);
                window.removeEventListener('pageshow', onPageShow);
                if (hls) {
                    try { hls.destroy(); } catch (_) {}
                }
            };
        } else {
            // Native playback (Safari) nebo přímý RTSP (LG webOS) / non-HLS URL.
            videoEl.src = liveCameraPlayableUrlResolved;
            tryPlay();

            // Fallback pojistka jen pro přímý RTSP: když do 8 s nezačne hrát
            // (webOS to neumí, kamera nedostupná, …), přepni na serverový HLS
            // most nastavením directRtspFailed → komponenta se přerenderuje a
            // liveCameraUseDirectRtsp spadne na false.
            if (liveCameraUseDirectRtsp) {
                const fail = () => { if (!cancelled) setDirectRtspFailed(true); };
                const onErr = () => fail();
                videoEl.addEventListener('error', onErr);
                const fallbackTimer = setTimeout(() => {
                    if (cancelled || !videoEl) return;
                    // readyState < 3 (HAVE_FUTURE_DATA) po 8 s = nehraje → fallback.
                    if (videoEl.readyState < 3 || videoEl.currentTime <= 0) fail();
                }, 8000);
                return () => {
                    cancelled = true;
                    clearTimeout(fallbackTimer);
                    videoEl.removeEventListener('error', onErr);
                };
            }
        }
        return () => { cancelled = true; };
    }, [kioskCfg.liveCameraEnabled, liveCameraPlayableUrlResolved, liveCameraIsHls, liveCameraUseDirectRtsp, liveReinit]);

    // Pro iframe stream (rtsp.me embed atd.) přidat autoplay parametry,
    // jinak prohlížeč/embed čeká na user click. Mute je nutný, protože
    // většina browserů blokuje neztišený autoplay.
    const liveCameraIframeSrc = liveCameraIsIframe
        ? (() => {
            const sep = liveCameraPlayableUrlResolved.includes('?') ? '&' : '?';
            return `${liveCameraPlayableUrlResolved}${sep}autoplay=1&mute=1&muted=1`;
        })()
        : liveCameraPlayableUrlResolved;

    const liveCameraView = kioskCfg.liveCameraEnabled && liveCameraPlayableUrlResolved ? (
        <div style={{ width: '100%', height: '100%', position: 'relative', background: '#000' }}>
            {liveCameraIsIframe ? (
                <iframe
                    key={`iframe|${liveCameraIframeSrc}`}
                    src={liveCameraIframeSrc}
                    title={kioskCfg.liveCameraName || 'Live camera'}
                    allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
                    allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                    style={{ width: '100%', height: '100%', border: 0, background: '#000' }}
                />
            ) : (
                <video
                    ref={liveVideoRef}
                    key={`${kioskCfg.liveCameraEnabled ? '1' : '0'}|${liveCameraPlayableUrlResolved}`}
                    src={!liveCameraIsHls ? liveCameraPlayableUrlResolved : undefined}
                    autoPlay
                    muted
                    playsInline
                    controls={false}
                    preload="auto"
                    style={{ width: '100%', height: '100%', objectFit: 'contain', background: '#000' }}
                />
            )}
            <div style={{ position: 'absolute', top: 10, left: 10, color: '#fff', background: 'rgba(0,0,0,0.5)', padding: '6px 10px', borderRadius: 4, fontSize: 14 }}>
                {kioskCfg.liveCameraName || 'Live camera'}
            </div>
        </div>
    ) : null;

    const mainContent = (
        <div
            className={`${classes.main} ${demoRatioClass}`.trim()}
            style={(newstep === 0 || newstep === 12) ? { backgroundColor: noMeetingBgColor } : undefined}
        >
            {showHeader && (
            <div className={classes.header} style={{ backgroundColor: headerBgColor }}>
                <div className={classes.hUp}>
                    {headerSections.map((section, idx) => (
                        <Fragment key={idx}>
                            {idx > 0 && <div className={classes.line} style={{ backgroundColor: headerTextColor }}></div>}
                            {section}
                        </Fragment>
                    ))}
                </div>
            </div>
        )}
        {liveCameraView ? liveCameraView : null}
        {!liveCameraView && newstep == 0 && (isViennaOrg ? mainMenu : genericNoGroupView)}
        {!liveCameraView && newstep == 1 && <Sleep setStep={setNewStep_handler} reset={resetscreen}/>}
        {!liveCameraView && newstep == 2 && <Eat setStep={setNewStep_handler} reset={resetscreen}/>}
        {!liveCameraView && newstep == 3 && <Meet setStep={setNewStep_handler} reset={resetscreen}/>}
        {!liveCameraView && newstep == 4 && <ExploreVienna setStep={setNewStep_handler} reset={resetscreen}/>}
        {!liveCameraView && (newstep == 10 || newstep == 11) && <div className={classes.meetGrid}>
            {newstep == 10 && <MeetingGraph language={language} changeStep={changeStep_handler} reset={resetscreen}/>}
            {newstep == 11 && <MeetingStairs2 org={props.org} changeStep={changeStep_handler} reset={resetscreen}/>}
        </div>}
        {!liveCameraView && newstep == 99 && meetingView}
        {!liveCameraView && newstep == 12 && (
            <div className={classes.slideshowWrap}>
                <SlideShowKiosk_redesign2
                    org={props.org}
                    changeStep={changeStep_handler}
                    groupID={group}
                    videoGroupId={kioskCfg.videoGroupId}
                    slideshowGroupId={kioskCfg.slideshowGroupId}
                    slideshowGroupIds={kioskCfg.slideshowGroupIds}
                    intervalMs={Math.max(1000, Number(kioskCfg.slideIntervalSec || 15) * 1000)}
                    objectFit={kioskCfg.objectFit}
                    backgroundColor={kioskCfg.backgroundColor || defaults.backgroundColor}
                    refreshTrigger={refreshTrigger}
                    webEmbedZoom={Number(kioskCfg.webEmbedZoom) > 0 ? Number(kioskCfg.webEmbedZoom) : defaults.webEmbedZoom}
                    webEmbedOffsetY={
                        typeof kioskCfg.webEmbedOffsetY === 'number' && Number.isFinite(kioskCfg.webEmbedOffsetY)
                            ? kioskCfg.webEmbedOffsetY
                            : defaults.webEmbedOffsetY
                    }
                />
            </div>
        )}

    </div>
    );

    return mainContent;
}
export default Kiosk_viennaPlzen_redesign